module.exports = __webpack_public_path__ + "static/header-loop-381ffd4fe622c9634719faae21e5fe3d.mp4";